import React from "react";
import {
    showAllQuery,
    useSearchQuestion,
    useSearchResults,
} from "../../context/DataContext";

import { bemClassName } from "../../utils/bemClassName";
import { joinClassNames } from "../../utils/joinClassNames";
import styles from "../SearchContents/SearchContents.module.css";

export const ResultsSummary = () => {
    const { resultsSummary: summary } = useSearchResults();
    const { query: searchQuery } = useSearchQuestion();
    const resultName = summary.totalMatching === 1 ? "result" : "results";
    const maybeQuery =
        searchQuery !== showAllQuery && searchQuery.trim() ? (
            <React.Fragment>
                {" "}
                for <strong>{searchQuery.trim()}</strong>
            </React.Fragment>
        ) : null;
    const maybeLastResult =
        summary.totalMatching > 1 ? (
            <React.Fragment>
                {" - "}
                <span id="search-page-end">{summary.currEnd}</span>
            </React.Fragment>
        ) : null;
    const maybeTotalResults =
        summary.totalMatching > 1 ? (
            <React.Fragment>
                {" "}
                of{" "}
                <span id="search-total-matching">{summary.totalMatching}</span>
            </React.Fragment>
        ) : null;
    return (
        <div
            id="search-result-count"
            className={joinClassNames([
                "text-muted",
                bemClassName("find-a-panel", "search-count"),
                styles.resultCount,
            ])}
        >
            Displaying <span id="search-page-start">{summary.currStart}</span>
            {maybeLastResult}
            {maybeTotalResults} {resultName}
            {maybeQuery}
        </div>
    );
};

export default ResultsSummary;
